import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const campaignPermissions = {
  view: "campaign.view",
  manage: "campaign.manage",
  request: { create: "campaign.request.create" },
};

// Campaign permissions are deliberately separate (NA-024, approved) and must not be
// merged or renamed. Today ceo-level, am, dmm, storeL and store hold all three
// request/use/edit permissions; campaign.manage (templates) adds dm and excludes
// the clients. tests/batch3.test.js pins each grant independently.
export const campaignGrants = {
  "campaign.view": rule(lud(R.DMM, R.AM, R.SALES, R.STORE_L, R.STORE, R.NEW)),
  // create / edit / remove campaign templates and the management cards
  "campaign.manage": rule(lud(R.AM, R.DM, R.DMM)),
  // request a campaign for a restaurant
  "campaign.request.create": rule(lud(R.AM, R.DMM, R.STORE_L, R.STORE), { scope: SCOPES.RESTAURANT }),
};
